import { EInvoiceTvaType } from "./e-invoice-tva.enum";

export class EInvoiceTvaAggregation {
  Name: string;
  TvaType: EInvoiceTvaType;
  VatPercent: number = 0;
  TvaBaseAmount: number = 0;
  TvaTotalAmount: number = 0;
}
